import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../pages/Home/components/Sidebar';
import { useSidebar } from '../contexts/SidebarContext';
import { useIsMobile } from '../hooks/useIsMobile';
import { BottomTabBar } from './mobile';
import { AccountSetupGate } from './AccountSetup';

const MainLayout: React.FC = () => {
  const { width: sidebarWidth } = useSidebar();
  const isMobile = useIsMobile();

  if (isMobile) {
    // A fixed-height column, not a page that scrolls behind a fixed bar: the trading
    // pages manage their own internal scrolling, and anchoring the nav in the flow is
    // what keeps it off the iOS URL bar as it shows and hides.
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100dvh',
          overflow: 'hidden',
          // `viewport-fit=cover` (index.html) lets the page run under the notch and the
          // rounded corners, which is what makes the insets non-zero for the tab bar. The
          // same switch means the shell has to give the top and sides back, or the header
          // sits under the status bar once launched from the home screen. All three read 0
          // in an ordinary portrait browser tab, so this costs nothing there.
          paddingTop: 'env(safe-area-inset-top)',
          paddingLeft: 'env(safe-area-inset-left)',
          paddingRight: 'env(safe-area-inset-right)',
        }}
      >
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
          <Outlet />
        </div>
        <BottomTabBar />
        <AccountSetupGate />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <div style={{ flex: 1, marginLeft: `${sidebarWidth}px`, transition: 'margin-left 0.2s ease', minWidth: 0 }}>
        <Outlet />
      </div>
      <AccountSetupGate />
    </div>
  );
};

export default MainLayout;
